import React, { Component } from "react";
import "../Ventas/ventas.css";
import "./afiliaciones.css";
import { toast } from "react-toastify";
import Navbar from "../../componentes/navbar/navbar";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import AfiliacionModal from "../../componentes/modal/AfiliacionModal";
import { agregarAfiliacion, editarAfiliacion, getListaAfiliacion, getListaMoneda } from "../../service/api";
import { CiEdit } from "react-icons/ci";
import { FaCheck, FaTimes } from "react-icons/fa";


export default class AfiliacionesPage extends Component {
  state = {
    loading: false,
    afiliaciones: [],
    filterText: "",
    showModal: false,
    modalMode: "create", // create | edit
    selected: null,
    selectedRowId: null,
    array_moneda: [],
    editingId: null,
    editingValue: "",
    inlineSaving: false,
    sortKey: "afiliacion",
    sortDir: "asc",
  };

  componentDidMount() {
    const datos = localStorage.getItem("datosm");
    if (!datos || datos === "") {
      window.location.href = "/";
      return;
    }

    this.getmonedas()
    this.fetchAfiliaciones();
  }
  getmonedas = async () => {
    var resp = await getListaMoneda();

    if (resp && resp.code === 0) {
      const array_moneda = resp.data || [];
      this.setState({ array_moneda });
    }

  }

  // ===== Helpers =====


  normalize = (a) => {
    return {
      idafiliacion: a?.idafiliacion ?? null,
      afiliacion: a?.afiliacion ?? "",
      banco: a?.banco ?? "",
      idmoneda: a?.idmoneda ?? "",
      moneda: a?.moneda ?? "",
      compania: a?.compania ?? "",
      facturable: a?.facturable ?? "",
      cuenta: a?.cuenta ?? "",
      comentarios: a?.comentarios ?? "",
      _key: String(a?.idafiliacion ?? Math.random()),
    };
  };

  compareValues = (a, b) => {
    if (a == null) a = "";
    if (b == null) b = "";

    const na = Number(a);
    const nb = Number(b);

    const bothNumeric =
      !Number.isNaN(na) &&
      !Number.isNaN(nb) &&
      String(a).trim() !== "" &&
      String(b).trim() !== "";

    if (bothNumeric) return na - nb;

    return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
  };

  getSortValue = (a, key) => {
    switch (key) {
      case "afiliacion":
        return a.afiliacion;
      case "banco":
        return a.banco;
      case "moneda":
        return a.moneda;
      case "cuenta":
        return a.cuenta;
      case "facturable":
        return a.facturable;
      case "compania":
        return a.compania;
      default:
        return "";
    }
  };

  onSort = (key) => {
    this.setState((prev) => {
      const same = prev.sortKey === key;
      const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
      return { sortKey: key, sortDir: nextDir };
    });
  };

  getSortedItems = (items) => {
    const { sortKey, sortDir } = this.state;

    return [...(items || [])].sort((aa, bb) => {
      const a = this.getSortValue(aa, sortKey);
      const b = this.getSortValue(bb, sortKey);
      const cmp = this.compareValues(a, b);
      return sortDir === "asc" ? cmp : -cmp;
    });
  };

  // ===== API =====
  fetchAfiliaciones = async () => {
    this.setState({ loading: true });

    try {
      const resp = await getListaAfiliacion();

      if (resp.code === 0) {
        const raw = Array.isArray(resp.data) ? resp.data : [];
        const afiliaciones = raw.map(this.normalize);
        this.setState({ afiliaciones, loading: false });
        return;
      }

      toast.info(resp.message || "No se pudieron obtener afiliaciones.");
      this.setState({ loading: false });
    } catch (e) {
      toast.info("Error al obtener afiliaciones.");
      this.setState({ afiliaciones: [], loading: false });
    }
  };

  //Guarda (create/edit)
  onSaveAfiliacion = async (payload) => {
    this.setState({ showModal: false, loading: true });

    try {
      const r =
        this.state.modalMode === "edit"
          ? await editarAfiliacion(payload, this.state.selected.idafiliacion)
          : await agregarAfiliacion(payload);

      if (r.code === 0) {
        toast.success(r.message || "Guardado.");
        this.setState({
          showModal: false,
          selected: null,
          modalMode: "create",
        });
        this.fetchAfiliaciones();
      } else {
        toast.info(`${r.code} - ${r.message}`);
        this.setState({ loading: false });
      }
    } catch (e) {
      toast.info("Error al guardar afiliación.");
      this.setState({ loading: false });
    }
  };


  startInlineEdit = (row) => {
    const id = row?.idafiliacion ?? null;
    if (!id) return;

    this.setState({
      editingId: id,
      editingValue: row?.afiliacion ?? "",
    });
  };

  cancelInlineEdit = () => {
    this.setState({
      editingId: null,
      editingValue: "",
    });
  };

  onChangeInlineValue = (e) => {
    this.setState({ editingValue: e.target.value });
  };

  saveInlineEdit = async (row) => {
    const id = row?.idafiliacion ?? null;
    if (!id) return;

    const afiliacion = String(this.state.editingValue || "").trim();

    if (!afiliacion) {
      toast.info("La afiliación no puede ir vacía.");
      return;
    }

    // (Opcional) si no cambió nada
    if (afiliacion === String(row?.afiliacion || "").trim()) {
      toast.info("No hay cambios para guardar.");
      this.cancelInlineEdit();
      return;
    }

    const payload = { afiliacion };

    try {
      this.setState({ savingInline: true });
      const r = await editarAfiliacion(payload, id);

      if (r.code === 0) {
        toast.success(r.message || "Afiliación actualizada.");
        this.setState({
          editingId: null,
          editingValue: "",
          savingInline: false,
        });
        this.fetchAfiliaciones();
        return;
      }

      toast.info(`${r.code} - ${r.message || "No se pudo guardar."}`);
      this.setState({ savingInline: false });
    } catch (e) {
      toast.info("Error al guardar la afiliación.");
      this.setState({ savingInline: false });
    }
  };


  // ===== UI =====
  openCreate = () => {
    this.setState({
      showModal: true,
      modalMode: "create",
      selected: null,
      selectedRowId: null,
    });
  };

  openEdit = (row) => {
    this.setState({
      showModal: true,
      modalMode: "edit",
      selected: row,
      selectedRowId: row?.idafiliacion ?? null,
    });
  };

  onSelectRow = (row) => {
    const id = row?.idafiliacion ?? null;
    this.setState((prev) => ({
      selectedRowId: prev.selectedRowId === id ? null : id, //  toggle
    }));
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      selected: null,
      modalMode: "create",
      selectedRowId: null,
    });
  };

  setFilterText = (e) => {
    this.setState({ filterText: e.target.value || "" });
  };

  getFilteredItems = () => {
    const q = String(this.state.filterText || "").trim().toLowerCase();
    const items = this.state.afiliaciones || [];
    if (!q) return items;

    return items.filter((a) => {
      const s = [
        a.afiliacion,
        a.banco,
        a.compania,
        a.cuenta,
        a.moneda,
        a.idmoneda,
      ]
        .join(" ")
        .toLowerCase();

      return s.includes(q);
    });
  };

  render() {
    const {
      loading,
      showModal,
      modalMode,
      selected,
      filterText,
      selectedRowId,
      array_moneda,
    } = this.state;

    const filtered = this.getFilteredItems();
    const items = this.getSortedItems(filtered);

    return (
      <div className="v-page">
        <Navbar />

        {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

        <AfiliacionModal
          show={showModal}
          mode={modalMode}
          afiliacion={selected}
          moneda={array_moneda}
          loading={loading}
          onClose={this.closeModal}
          onSave={this.onSaveAfiliacion}
        />

        <div className="a-shell">
          <div className="v-top">
            <h1 className="v-title">Afiliaciones</h1>

            <div className="a-actions">
              <div className="so-search">
                <span className="so-ico" aria-hidden="true">🔎</span>

                <input
                  type="text"
                  value={filterText}
                  onChange={(e) => this.setState({ filterText: e.target.value, selectedRowId: null })}
                  placeholder="Buscar Banco, Moneda, Cuenta..."
                  disabled={loading}
                />

                {String(filterText || "").length > 0 && (
                  <button
                    type="button"
                    className="so-clear"
                    onClick={() => this.setState({ filterText: "", selectedRowId: null })}
                    disabled={loading}
                    aria-label="Limpiar"
                    title="Limpiar"
                  >
                    ✕
                  </button>
                )}
              </div>

              <button className="v-btn" onClick={this.openCreate} disabled={loading}>
                AGREGAR AFILIACIÓN
              </button>
            </div>
          </div>

          <div className="vard">
            <div className="v-card">
              <div className={`v-tableWrap ${showModal ? "lock-scroll" : ""}`}>
                <table className="v-table">
                  <thead>
                    <tr>

                      <th className="v-thSort" onClick={() => this.onSort("afiliacion")}>
                        Afiliación
                      </th>
                      <th className="v-thSort" onClick={() => this.onSort("banco")}>
                        Banco
                      </th>
                      <th className="v-thSort" onClick={() => this.onSort("moneda")}>
                        Moneda
                      </th>
                      <th className="v-thSort" onClick={() => this.onSort("cuenta")}>
                        Banco Cuenta
                      </th>
                      <th className="v-thSort" onClick={() => this.onSort("compania")}>
                        Compañía
                      </th>
                      <th className="v-thSort" onClick={() => this.onSort("facturable")}>
                        Facturable
                      </th>
                   
                      <th>Acciones</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="v-empty">
                          No hay registros disponibles
                        </td>
                      </tr>
                    ) : (
                      items.map((a, idx) => {
                        const isActive = selectedRowId === a.idafiliacion;

                        const rowClass = [
                          idx % 2 === 0 ? "even" : "odd",
                          isActive ? "row-active" : "",
                        ]
                          .join(" ")
                          .trim();

                        return (
                          <tr
                            key={`${a._key}-${idx}`}
                            className={rowClass}
                            onClick={() => this.onSelectRow(a)}
                            style={{ cursor: "pointer" }}
                          >
                            <td className="v-mono" onClick={(e) => e.stopPropagation()}>
                              {this.state.editingId === a.idafiliacion ? (
                                <div className="a-inlineEdit">
                                  <input
                                    className="a-inlineInput"
                                    value={this.state.editingValue}
                                    onChange={this.onChangeInlineValue}
                                    autoFocus
                                    disabled={this.state.savingInline || loading}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") this.saveInlineEdit(a);
                                      if (e.key === "Escape") this.cancelInlineEdit();
                                    }}
                                  />

                                  <div className="a-inlineBtns">
                                    <button
                                      className="a-iconBtn ok"
                                      title="Guardar"
                                      onClick={() => this.saveInlineEdit(a)}
                                      disabled={this.state.savingInline || loading}
                                    >
                                      <FaCheck />
                                    </button>

                                    <button
                                      className="a-iconBtn cancel"
                                      title="Cancelar"
                                      onClick={this.cancelInlineEdit}
                                      disabled={this.state.savingInline || loading}
                                    >
                                      <FaTimes />
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className="a-inlineView" onClick={() => this.onSelectRow(a)}>
                                  <button
                                    className="a-pencilBtn"
                                    title="Editar afiliación"
                                    onClick={() => this.startInlineEdit(a)}
                                    disabled={loading}
                                  >
                                    <CiEdit />
                                  </button>

                                  <span className="a-inlineText">{a.afiliacion}</span>
                                </div>
                              )}
                            </td>
                            <td>{a.banco}</td>
                            <td>{a.moneda}</td>
                            <td className="v-mono">{a.cuenta}</td>
                           
                            <td>{a.compania}</td>

                            <td>{Number(a.facturable) === 1 ? "Sí" : "No"}</td>

         
                            <td onClick={(e) => e.stopPropagation()}>
                              <button
                                className="a-linkBtn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.openEdit(a);
                                }}
                                disabled={loading}
                                title="Editar"
                              >
                                Editar
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
